import { create } from 'zustand';

interface MediaSwapState {
  target: { frameId: string; cfNodeId: string } | null;
  open: (frameId: string, cfNodeId: string) => void;
  close: () => void;
}

export const useMediaSwapStore = create<MediaSwapState>((set) => ({
  target: null,
  open: (frameId, cfNodeId) => set({ target: { frameId, cfNodeId } }),
  close: () => set({ target: null }),
}));
